
/**
 * 주문 상태
 */
export type OrderResponseStatus = typeof OrderResponseStatus[keyof typeof OrderResponseStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderResponseStatus = {
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  COMPLETED: 'COMPLETED',
  PAID: 'PAID',
  CANCELLED: 'CANCELLED',
  FAILED: 'FAILED',
  REFUNDED: 'REFUNDED',
} as const;
